import sylvetteLibrary from './sylvetteLibrary.json';
import { SYLVETTE_MINKY_SWATCHES } from './sylvetteSwatches';
import { CHARACTER_NAMES, characterSlug } from '../../lib/characters';
import { DEFAULT_CUSTOM_PRICE } from '../../lib/shop';

export const MODEL_DETAILS = {
  'sylvette-la-crevette': {
    name: CHARACTER_NAMES['sylvette-la-crevette'],
    short: 'Sylvette',
    character: 'La rêveuse',
    color: '#efd1d6',
    description:
      'Une petite crevette courbée, pour les pages qu’on aime relire.',
  },
  'leon-le-citron': {
    name: CHARACTER_NAMES['leon-le-citron'],
    short: 'Léon',
    character: 'Le taquin',
    color: '#e9e5b7',
    description: 'Un citron tout doux, avec juste ce qu’il faut de caractère.',
  },
  'pralin-le-cornet': {
    name: CHARACTER_NAMES['pralin-le-cornet'],
    short: 'Pralin',
    character: 'Le gourmand',
    color: '#ead8bf',
    description: 'Une boule de douceur sur son petit cornet cousu.',
  },
  'pepin-le-sorbet': {
    name: CHARACTER_NAMES['pepin-le-sorbet'],
    short: 'Pépin',
    character: 'L’espiègle',
    color: '#efd5ca',
    description:
      'Un sorbet à rayures qui ne fond jamais, même au dernier chapitre.',
  },
  'camille-la-coquille': {
    name: CHARACTER_NAMES['camille-la-coquille'],
    short: 'Camille',
    character: 'La tranquille',
    color: '#cddfe9',
    description: 'Une coquille en éventail, complice des lectures au calme.',
  },
};

export const canonicalSlug = characterSlug;
export const hasIndependentRibbon = slug =>
  Object.prototype.hasOwnProperty.call(MODEL_DETAILS,canonicalSlug(slug));
export const GROUPS = ['front_fabric', 'back_fabric', 'ribbon_fabric', 'ribbon', 'embroidery'];
export const PEPIN_FRONT_GROUPS = ['front_fabric','front_fabric_middle','front_fabric_bottom'];
export const hasConfigurableBands = slug => canonicalSlug(slug)==='pepin-le-sorbet';
export const groupsForModel = slug => hasConfigurableBands(slug)
  ? [...PEPIN_FRONT_GROUPS,...GROUPS.slice(1)] : GROUPS;
export const PEPIN_DEFAULTS = {
  front_fabric:'fuchsia-minkee',front_fabric_middle:'honey-minkee',front_fabric_bottom:'pink-minkee',
  back_fabric:'blue-flowers',ribbon_fabric:'blue-flowers',ribbon:'gold',embroidery:'original',
};
export const LABELS = {
  front_fabric: 'Minkee du devant',
  front_fabric_middle:'Bande du milieu',
  front_fabric_bottom:'Bande du bas',
  back_fabric: 'Coton du dos',
  ribbon_fabric: 'Tissu du ruban',
  ribbon: 'Fil de couture',
  embroidery: 'Visage du modèle',
};
export const available = (option) =>
  option.active !== false && (option.stock == null || option.stock > 0);

export const fabricMaterial = (option) => option?.material ||
  (option?.option_id?.endsWith('-minkee') ? 'minky' : 'liberty');

export function optionsForModel(options, rawSlug) {
  const slug = canonicalSlug(rawSlug);
  return options.filter(option =>
    (!option.models?.length || option.models.includes(slug)) &&
    (hasIndependentRibbon(slug) || option.group !== 'ribbon_fabric'))
    .map(option => {
      const swatch = hasIndependentRibbon(slug) &&
        (SYLVETTE_MINKY_SWATCHES[option.option_id] || sylvetteLibrary.liberty[option.option_id]?.swatch || sylvetteLibrary.colors[option.option_id]?.swatch);
      return swatch ? {...option, swatch_image: swatch} : option;
    });
}

export const configurationLabel = (group, slug) =>
  group==='front_fabric'&&hasConfigurableBands(slug)?'Bande du haut':
  group === 'back_fabric' && hasIndependentRibbon(slug)
    ? 'Tissu du dos' : LABELS[group];

export function resolveSelection(ids, options, slug) {
  return Object.fromEntries(
    groupsForModel(slug).map((group) => [
      group,
      options.find(
        (option) =>
          option.group === group &&
          option.option_id === (group === 'embroidery' ? 'original' : ids[group]) &&
          available(option),
      ) || null,
    ]),
  );
}

export function configurationReady(selection, options, slug) {
  return groupsForModel(slug).every(
    (group) =>
      (['back_fabric', 'ribbon_fabric'].includes(group) && !options.some((o) => o.group === group)) ||
      Boolean(selection[group]),
  );
}

export function configurationPrice(product, selection) {
  const base =
    typeof product?.custom_price === 'number' ? product.custom_price : DEFAULT_CUSTOM_PRICE;
  return (
    Math.round(
      (base +
        Object.values(selection).reduce(
          (sum, option) => sum + (Number(option?.price) || 0),
          0,
        )) *
        100,
    ) / 100
  );
}

export function buildPayload(product, selection) {
  return {
    configuration_version: hasConfigurableBands(product.slug)?4:selection.ribbon_fabric ? 3 : 2,
    product_slug: canonicalSlug(product.slug),
    product_name: MODEL_DETAILS[canonicalSlug(product.slug)]?.name || product.name,
    product_price: product.price,
    total_price: configurationPrice(product, selection),
    ...Object.fromEntries(
      groupsForModel(product.slug).map((group) => [
        group,
        selection[group]
          ? {
              option_id: selection[group].option_id,
              option_name: selection[group].name,
              price: selection[group].price || 0,
            }
          : null,
      ]),
    ),
  };
}
